import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,selector: '[click]'
})
export class CursorPointerDirective {

  @HostBinding('style.cursor') cursor: string = 'pointer';

}
